import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import stylesJS from './styles';
import styles from './styles.module.scss';

const variants = ['base', 'gray', 'green', 'darkBlue', 'red'];

function UTBullet({ content, lastItem, withLine, ...props }) {
  const style = variants.filter(variant => props[variant]).map(variant => stylesJS[variant]);
  return (
    <div style={[stylesJS.container, props.style]}>
      <div>
        <svg height="20px" width="20px" style={[stylesJS.dot, style]}>
          <circle cx={10} cy={10} r={4} />
        </svg>
      </div>
      <UTLabel
        light
        small
        className={withLine && !lastItem ? styles.text : styles.last}
        style={{ ...style[0] }}
      >
        {content}
      </UTLabel>
    </div>
  );
}

UTBullet.propTypes = {
  content: PropTypes.string.isRequired,
  lastItem: PropTypes.bool,
  withLine: PropTypes.bool
};

export default Radium(UTBullet);
